import { NotificationType, useModelsByTier, useTranslation } from "@next-platform/client-common-core";
import React from "react";

import { Col } from "@/components";
import { useInferenceSettings } from "@/hooks";
import useToast from "@/hooks/useToast";

import ModelSelectionHeader from "./ModelSelectionHeader";
import ModelSelectionItem from "./ModelSelectionItem";

const AvailableModelSelection = ({
  toggleView,
  closeDropdown,
}: {
  toggleView: () => void;
  closeDropdown: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { getAvailableModels } = useModelsByTier();
  const { displayToast } = useToast();
  const { t } = useTranslation();
  const { inferenceModel: selectedModelId, updateInferenceModel } = useInferenceSettings();
  const goBack = () => {
    toggleView();
  };
  const availableModels = getAvailableModels();
  const changeModelHandler = ({ id, name }: { id: string; name: string }) => {
    updateInferenceModel(id);
    displayToast({ message: t("chat:page.header.modelSelection.dropdown.switchModel.toast", { modelName: name }), type: NotificationType.success });
    goBack();
    closeDropdown(false);
  };
  return (
    <Col className="py-sm">
      <ModelSelectionHeader canGoBack={true} clickHandler={goBack} />
      <Col className="max-w-[330px] max-h-[531px] overflow-y-auto custom-scroll">
        {availableModels.map((m) => {
          if (!m) {
            return null;
          }
          return <ModelSelectionItem model={m} key={m.id} activeModel={selectedModelId} clickHandler={changeModelHandler} />;
        })}
      </Col>
    </Col>
  );
};

export default AvailableModelSelection;
